var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mu-snackbar',{staticClass:"info-popup bsb",class:{ 'error-info-class':!_vm.common.infopopup.infostate },style:({ bottom: _vm.common.infopopup.bottom + 'px' }),attrs:{"message":_vm.common.infopopup.infomsg}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.5.0@vue-loader/lib/template-compiler?{"id":"data-v-1fb21797","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/infoPopup.vue
// module id = null
// module chunks = 